export const BARCLAYS_SAVE_DATA = "BARCLAYS_SAVE_DATA";
